<template>
  <span class="notification-popups" v-if="notifications.length">
    <span class="notification-item-wrapper"
    v-for="notification, index in notifications">
      <close-icon @click.native="close(index)" tabindex="0" class="close"></close-icon>
      <notification-item
        @dismissed="close(index)"
        :notification="notification"
      ></notification-item>
    </span>
  </span>
</template>

<style lang="less" scoped>
.notification-popups {
  list-style-type: none;
  top: -2px;
  right: 155px;
  position: absolute;
  z-index: 10;
  .notification-item-wrapper {
    border-radius: 4px;
    width: 93vw;
    max-width: 400px;
    display: block;
    left: 50% !important;
    padding: 20px 40px 5px 20px;
    box-shadow: 0px 0px 15px 0px rgba(57, 57, 57, 0.16);
    z-index: 1001;
    transition: opacity 0.3s;
    background-color: white;
    margin-top: 1em;
  }
  .close {
    float: right;
    fill: #aaa;
    display: block;
    font-size: 32px;
    cursor: pointer;
    margin: -15px -20px 0 0;
    &:hover {
      cursor: pointer;
      fill: #666;
    }
  }
  @media (max-width: 980px) {
    right: 20px;
  }
  @media (max-width: 775px) {
    right: 10px;
  }
}
</style>

<script>
  import NotificationItem from "./NotificationItem.vue";
  import axios from "axios";

  export default {
    props: ["notifications"],
    components: { NotificationItem },
    methods: {
      close(index) {
        axios.post(`/api/activity/dismiss-popup/${this.notifications[index].id}`);
        let popups = [...this.notifications]
        popups.splice(index, 1)
        this.$store.commit('setPopups', popups)
      }
    }
  }
</script>
